/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Medical = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M15.97 15.97V17.61H17.61V15.97H15.97ZM15.97 28.03H17.61V26.39H15.97V28.03ZM28.03 28.03V26.39H26.39V28.03H28.03ZM28.03 15.97H26.39V17.61H28.03V15.97ZM26.39 7.27H29.66C29.66 5.46 28.19 4 26.39 4V7.27ZM17.61 7.27H26.39V4H17.61V7.27ZM17.61 7.27V4C15.8 4 14.34 5.47 14.34 7.27H17.61ZM17.61 15.97V7.27H14.34V15.97H17.61ZM7.27 17.61H15.97V14.34H7.27V17.61ZM7.27 17.61V14.34C5.46 14.34 4 15.81 4 17.61H7.27ZM7.27 26.39V17.61H4V26.39H7.27ZM7.27 26.39H4C4 28.2 5.47 29.66 7.27 29.66V26.39ZM15.97 26.39H7.27V29.66H15.97V26.39ZM17.61 36.73V28.03H14.34V36.73H17.61ZM17.61 36.73H14.34C14.34 38.54 15.81 40 17.61 40V36.73ZM26.39 36.73H17.61V40H26.39V36.73ZM26.39 36.73V40C28.2 40 29.66 38.53 29.66 36.73H26.39ZM26.39 28.03V36.73H29.66V28.03H26.39ZM36.73 26.39H28.03V29.66H36.73V26.39ZM36.73 26.39V29.66C38.54 29.66 40 28.19 40 26.39H36.73ZM36.73 17.61V26.39H40V17.61H36.73ZM36.73 17.61H40C40 15.8 38.53 14.34 36.73 14.34V17.61ZM28.03 17.61H36.73V14.34H28.03V17.61ZM26.39 7.27V15.97H29.66V7.27H26.39Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default Medical
